export const operatorsPrefix = [{
    'operator': 'همراه اول',
    'items': [
        "0910",
        "0911",
        "0913",
        "0914",
        "0915",
        "0916",
        "0917",
        "0918",
        "0919",
        "0990",
        "0991",
        "0992",
        "0993",
        "0994"
    ]
},
    {
        'operator': 'ایرانسل',
        'items': [
            "0930",
            "0933",
            "0934",
            "0935",
            "0936",
            "0937",
            "0938",
            "0939",
            "0901",
            "0902",
            "0903",
            "0904",
            "0905",
            "0941"
        ]
    },
    {
        'operator': 'رایتل',
        'items': [
            "0920",
            "0921",
            "0922"
        ]
    }
];

export function getProduct(operator) {
    if (operator === 'ایرانسل') {
        return 5;
    } else if (operator === 'همراه اول') {
        return 4;
    } else if (operator === 'رایتل') {
        return 2;
    }
    return 0;
}

export function getOperatorEnName(operator) {
    if (operator === 'ایرانسل') {
        return 'mtn';
    } else if (operator === 'همراه اول') {
        return 'mci';
    } else if (operator === 'رایتل') {
        return 'rightel';
    }
}

export function getOperatorBgColor(operator) {
    if (operator === 'ایرانسل') {
        return '#f7c505'
    } else if (operator === 'همراه اول') {
        return '#54c5d0'
    } else if (operator === 'رایتل') {
        return '#942a68';
    }
    return '';
}
